<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">{{ title }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <nf-form-control label="Calculate From">
    <nf-radio-group [formControl]="radioSource">
      <nf-radio-button label="Custody" value="1" inline></nf-radio-button>
      <nf-radio-button label="Trading" value="2" inline></nf-radio-button>
    </nf-radio-group>
  </nf-form-control>
  <p id="valuePara" *nfLoader="loadingPrice">
    {{ message }}
    <button
      (click)="usePrice()"
      nf-icon-button
      icon="content-copy"
      ngbTooltip="Use this Price"
    ></button>
  </p>
  <span id="tooltip-icon" class="mdi mdi-information-outline"></span>
  <span id="info"
    >Where available, these prices are sourced from External Market Prices
    received in the data provider’s position file as of the Recon Date of your
    loaded Session.</span
  >
</div>
